import dayjs from 'dayjs';
import { defineComponent, computed } from 'vue';

var script = defineComponent({
    name: 'DateBadge',
    props: {
        date: {
            type: Object,
            required: true,
        },
        dayOfWeek: Boolean,
        color: {
            type: String,
            default: 'blue',
        },
        showTime: Boolean,
        customBottomText: {
            type: String,
            default: undefined,
        },
    },
    setup(props) {
        const dateElements = computed(() => {
            const { date } = props;
            if (!date.timestamp)
                return {};
            const dayjsDate = dayjs(date.timestamp).tz(date.timeZone);
            const elements = {
                month: props.dayOfWeek ? undefined : dayjsDate.format('MMM'),
                dayOfWeek: props.dayOfWeek ? dayjsDate.format('ddd') : undefined,
                day: dayjsDate.format('D'),
            };
            if (props.showTime) {
                const minutes = dayjsDate.format('mm');
                if (minutes === '00') {
                    elements.bottom = dayjsDate.format('h A');
                }
                else {
                    elements.bottom = dayjsDate.format('h:mm A');
                }
            }
            if (props.customBottomText) {
                elements.bottom = props.customBottomText;
            }
            return elements;
        });
        const getDateClasses = computed(() => {
            const { color } = props;
            return `DateBadge__session-date--${color}`;
        });
        return {
            dateElements,
            getDateClasses,
        };
    },
});

export { script as default };
